import React, { useState, useRef, useEffect } from "react";
import DashboardLayout from "../common/DashboardLayout";
import { Link, useSearchParams } from "react-router-dom";
import TeacherServices from "../../services/TeacherServices";
import VimeoPlayer from "../vimeo";
import QuizServices from "../../services/QuizServices";
import Swal from "sweetalert2";
const Test = () => {
  const [searchParams] = useSearchParams();

  const [apiResponse, setApiResponse] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [videoPlayed, setVideoPlayed] = useState(false);
  const [showQuestion, setShowQuestion] = useState(false);
  // Store saved progress to use when continuing
  const savedProgressRef = useRef({ currentGroupIndex: 0, currentVideoIndex: 0 });
  const [message, setMessage] = useState("");
  const [showReplay, setShowReplay] = useState(false);
  const [iscompleted, setiscompleted] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [answerSelected, setAnswerSelected] = useState(false);
  const [showIsContinue, setShowIsContinue] = useState(false);
  const [isAfterVideoVimeo, setIsAfterVideoVimeo] = useState(false);
  const [afterVideoVimeoId, setAfterVideoVimeoId] = useState(null);
  var roleStr = localStorage.getItem("userrole");

  // Normalize role for DashboardLayout
  let role = 3; // Default to individual teacher
  if (roleStr === "1" || roleStr === 1) {
    role = 1; // School Admin
  } else if (roleStr === "2" || roleStr === 2) {
    role = 2; // School Teacher
  } else if (roleStr === "3" || roleStr === 3) {
    role = 3; // Individual Teacher
  } else if (roleStr === "admin" || roleStr === '"admin"') {
    role = "admin";
  } else if (roleStr === "4" || roleStr === "state" || roleStr === 4) {
    role = 4; // State Admin
  }

  const finalRole = typeof role === 'string' && role === '3' ? 3 :
    typeof role === 'string' && role === '2' ? 2 :
      typeof role === 'string' && role === '1' ? 1 :
        typeof role === 'string' && role === '4' ? 4 :
          typeof role === 'string' && role === 'admin' ? 'admin' :
            typeof role === 'string' && role === 'state' ? 4 :
              Number(role) || role || 3;

  // Get user type for role 1 (School)
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.type || null;

  // Get teacher_id from URL params or fallback to current user's ID
  const getTeacherId = () => {
    const urlTeacherId = searchParams.get("teacher_id");
    if (urlTeacherId) {
      return urlTeacherId;
    }
    // Fallback: use current user's ID for solo teachers (role 3) and school teachers (role 2)
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user?._id || user?.id || null;
  };
  const teacherId = getTeacherId();

  // ✅ Fetch Videos Properly
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await TeacherServices.getVideosWithQuiz(teacherId);
        console.log("API Response:", response);
        if (response && response.videos) {
          setApiResponse(response);
        }
        // Don't set iscompleted here - let checkProcess handle it
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, [teacherId]);

  useEffect(() => {
    const checkProcess = async () => {
      // Check URL query parameters first (for direct navigation from dashboard)
      const urlVideoIndex = searchParams.get('videoIndex');
      const urlGroupIndex = searchParams.get('groupIndex');
      const isRevisit = searchParams.get('revisit') === 'true';

      if (urlVideoIndex !== null) {
        const videoIdx = parseInt(urlVideoIndex, 10);
        const groupIdx = parseInt(urlGroupIndex || '0', 10);
        if (!isNaN(videoIdx) && videoIdx >= 0) {
          setCurrentVideoIndex(videoIdx);
          setCurrentGroupIndex(groupIdx);

          // Check if this is a retake OR a completed module to skip video
          try {
            const [videosResponse, progressResponse] = await Promise.all([
              TeacherServices.getVideosWithQuiz(teacherId),
              QuizServices.checkProcess(teacherId)
            ]);

            let shouldSkip = false;

            // 1. Global Retake Mode (Entire course completed)
            if (videosResponse && videosResponse.is_quiz_retake) {
              console.log("Global Retake mode detected - Skipping video");
              shouldSkip = true;
            }

            // 2. Previously Completed Module (User is ahead of this video)
            // SIMPLIFICATION: We removed the auto-skip logic here.
            // Videos will ALWAYS play when loaded.
            // Old logic checked (progressResponse && videoIdx < progressResponse.currentVideoIndex)

            // 3. Current Module In Progress (User has started quizzes) - REMOVED to force video play
            // else if (progressResponse && videoIdx === progressResponse.currentVideoIndex && progressResponse.currentGroupIndex > 0) {
            //   console.log("Module In Progress (Quizzes started) - Skipping video");
            //   shouldSkip = true;
            // }

            if (shouldSkip) {
              setVideoPlayed(true);
              setShowQuestion(true);
            } else {
              setVideoPlayed(false);
              setShowQuestion(false);
            }
          } catch (e) {
            console.error("Error checking status:", e);
            setVideoPlayed(false);
            setShowQuestion(false);
          }

          setiscompleted(false);
          setShowIsContinue(true);
          return; // Don't check saved process if URL params are provided
        }
      }

      try {
        // First check for saved progress
        const progressResponse = await QuizServices.checkProcess(teacherId);

        // Check if course is completed
        const videosResponse = await TeacherServices.getVideosWithQuiz(teacherId);

        // Only show completion if course is completed AND there's no progress to resume
        if (videosResponse && videosResponse.is_quiz_retake) {
          // Check if there's any progress to resume from
          if (progressResponse && (progressResponse.currentGroupIndex !== 0 || progressResponse.currentVideoIndex !== 0)) {
            // There's progress, auto-continue without popup
            savedProgressRef.current = {
              currentGroupIndex: progressResponse.currentGroupIndex,
              currentVideoIndex: progressResponse.currentVideoIndex
            };
            setCurrentGroupIndex(progressResponse.currentGroupIndex);
            setCurrentVideoIndex(progressResponse.currentVideoIndex);
            setiscompleted(false);
            // Auto-continue: determine if we should show video or question
            if (progressResponse.currentGroupIndex > 0) {
              setVideoPlayed(true);
              setShowQuestion(true);
            } else {
              setVideoPlayed(false);
              setShowQuestion(false);
            }
          } else {
            // No progress, course is truly completed - show module list instead of auto-starting
            setiscompleted(true);
            setShowIsContinue(false);
            setVideoPlayed(false);
            setShowQuestion(false);
          }
        } else if (progressResponse && (progressResponse.currentGroupIndex !== 0 || progressResponse.currentVideoIndex !== 0)) {
          // There's progress to resume from - auto-continue without popup
          savedProgressRef.current = {
            currentGroupIndex: progressResponse.currentGroupIndex,
            currentVideoIndex: progressResponse.currentVideoIndex
          };
          setCurrentGroupIndex(progressResponse.currentGroupIndex);
          setCurrentVideoIndex(progressResponse.currentVideoIndex);
          setiscompleted(false);
          // Auto-continue: determine if we should show video or question
          if (progressResponse.currentGroupIndex > 0) {
            setVideoPlayed(true);
            setShowQuestion(true);
          } else {
            setVideoPlayed(false);
            setShowQuestion(false);
          }
        } else {
          // No progress, course not completed
          setShowIsContinue(false);
          setiscompleted(false);
          setVideoPlayed(false);
          setShowQuestion(false);
        }
      } catch (error) {
        console.error("Error getting process:", error);
        setShowIsContinue(false);
        setiscompleted(false);
        setVideoPlayed(false);
        setShowQuestion(false);
      }
    };

    checkProcess();
  }, [teacherId]);
  // useEffect(() => {
  //   const disableLinks = (disable) => {
  //     document.querySelectorAll("a").forEach(link => {
  //       link.style.pointerEvents = disable ? "none" : "auto";
  //       link.style.color = disable ? "gray" : "";
  //     });
  //   };

  //   disableLinks(showQuestion);

  //   return () => disableLinks(false);
  // }, [showQuestion]);
  // useEffect(() => {
  //   const disableNavigation = () => {
  //     window.history.pushState(null, "", window.location.href);
  //   };

  //   if (showQuestion) {
  //     window.history.pushState(null, "", window.location.href);
  //     window.addEventListener("popstate", disableNavigation);
  //   } else {
  //     window.removeEventListener("popstate", disableNavigation);
  //   }

  //   return () => {
  //     window.removeEventListener("popstate", disableNavigation);
  //   };
  // }, [showQuestion]);

  // useEffect(() => {
  //   const blockActions = (event) => event.preventDefault();

  //   if (showQuestion) {
  //     document.addEventListener("contextmenu", blockActions);
  //     document.addEventListener("keydown", (event) => {
  //       if (event.ctrlKey && (event.key === "u" || event.key === "s" || event.key === "i" || event.key === "c")) {
  //         event.preventDefault();
  //       }
  //     });
  //   } else {
  //     document.removeEventListener("contextmenu", blockActions);
  //   }

  //   return () => {
  //     document.removeEventListener("contextmenu", blockActions);
  //   };
  // }, [showQuestion]);

  const enableLinks = () => {
    document.querySelectorAll("a").forEach((link) => {
      link.style.pointerEvents = "auto";
      link.style.color = "";
    });
  };
  // ✅ Keep Blocking Browser Navigation
  //   const disableNavigation = () => {
  //     history.pushState(null, "", location.href);
  // };
  // const blockActions = (event) => {
  //   event.preventDefault(); // Prevent default right-click and keyboard shortcuts
  // };
  const enableNavigation = () => {
    window.removeEventListener("popstate", disableNavigation);
  };

  const enableRightClickAndShortcuts = () => {
    document.removeEventListener("contextmenu", blockActions);
  };

  const [selectedOptions, setSelectedOptions] = useState({});

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (!answerSelected) {
      setSelectedOptions({ [name]: true }); // Allow only one selection
      handleAnswer(name); // Check answer immediately
      setAnswerSelected(true); // Disable further selection
    }
  };
  const handleRestartProcess = async () => {
    setCurrentGroupIndex(0);
    setCurrentVideoIndex(0);
    setCurrentQuestionIndex(0);
    setShowIsContinue(false);
    setVideoPlayed(false);
    setShowQuestion(false);
    setShowReplay(false);
    setMessage("");
    setQuizCompleted(false);
    setAnswerSelected(false);
    setSelectedOptions({});
    setiscompleted(false);

    // Reset progress on backend
    try {
      await QuizServices.saveProcess(0, 0, teacherId);
    } catch (error) {
      console.error("Error resetting progress:", error);
    }
  };

  const handleContinueProcess = () => {
    // When continuing, ensure the video/question state is properly set
    // Use saved progress from ref to avoid stale state issues
    const savedGroupIndex = savedProgressRef.current.currentGroupIndex;
    const savedVideoIndex = savedProgressRef.current.currentVideoIndex;

    setShowIsContinue(false);
    setiscompleted(false); // Make sure completion screen is hidden when continuing
    setShowReplay(false);
    setMessage("");
    setAnswerSelected(false);
    setSelectedOptions({});
    setQuizCompleted(false);

    // Ensure state is set to saved values
    setCurrentGroupIndex(savedGroupIndex);
    setCurrentVideoIndex(savedVideoIndex);

    // Determine if we should show video or question based on progress
    // If currentGroupIndex > 0, user has already watched the video for this group
    // and should see the question instead
    if (savedGroupIndex > 0) {
      // User is in the middle of a quiz - they've watched the video, show question
      setVideoPlayed(true);
      setShowQuestion(true);
    } else {
      // User is at the start of a new video/group - show video first
      setVideoPlayed(false);
      setShowQuestion(false);
    }

    // Reset question index to 0 when continuing (they'll start from first question of current group)
    setCurrentQuestionIndex(0);
  };
  // ✅ Get current video, group, and question
  const currentVideo = apiResponse?.videos?.[currentVideoIndex]; //groups?.videos?.[currentVideoIndex];//
  const currentGroup = currentVideo?.quizzes?.[currentGroupIndex];
  const currentQuestion = currentGroup?.questions?.[currentQuestionIndex];

  // ✅ FIX: video 8 has no quiz, so we need to fallback to the video url
  let currentVideoVimeoId = currentGroup?.videoVimeoId?.trim();
  if (!currentVideoVimeoId && currentVideo?.url) {
    // Extract ID from URL like "https://vimeo.com/123456"
    const matches = currentVideo.url.match(/vimeo\.com\/(\d+)/);
    if (matches && matches[1]) {
      currentVideoVimeoId = matches[1];
    }
  }
  //alert(currentVideoVimeoId);

  console.log("apiResponse", apiResponse);

  const handleFinishCourse = async () => {
    console.log("Manual Finish Course triggered.");

    // Mark as complete in backend
    const quizId = currentGroup?._id || currentGroup?.quizId || currentGroup?.id || null;
    if (quizId) {
      await QuizServices.completeProcess(teacherId, null, quizId);
    }

    await QuizServices.saveProcess(0, currentVideoIndex + 1, teacherId);

    Swal.fire({
      title: "Course Completed!",
      text: "Congratulations! You have finished the course.",
      icon: "success",
      timer: 5000,
      showConfirmButton: false
    }).then(() => {
      window.location.href = "/main-dashboard";
    });
  };

  const handleVideoEnd = async () => {
    setVideoPlayed(true);
    if (isAfterVideoVimeo) {
      setShowQuestion(false);
      await QuizServices.saveProcess(
        0,
        currentVideoIndex + 1,
        teacherId
      );

      Swal.fire({
        title: "Module Completed!",
        text: "You have finished this module. Returning to dashboard...",
        icon: "success",
        timer: 5000,
        showConfirmButton: false
      }).then(() => {
        window.location.href = "/main-dashboard";
      });
      return;
    }

    // ✅ FIX: Video 8 (Index 7) has no quiz. Auto-complete and finish course.
    if (currentVideoIndex === 7) {
      console.log("Video 8 completed. Auto-completing course...");

      // Mark as complete in backend
      const quizId = currentGroup?._id || currentGroup?.quizId || currentGroup?.id || null;
      if (quizId) {
        await QuizServices.completeProcess(teacherId, null, quizId);
      }

      await QuizServices.saveProcess(0, currentVideoIndex + 1, teacherId);

      Swal.fire({
        title: "Course Completed!",
        text: "Congratulations! You have finished the course.",
        icon: "success",
        timer: 5000,
        showConfirmButton: false
      }).then(() => {
        window.location.href = "/main-dashboard";
      });
      return;
    }

    else {
      setShowQuestion(true);
    }
    if (currentGroup?.questions.length === 0) {
      setQuizCompleted(true);

      try {
        await QuizServices.saveProcess(
          0,
          apiResponse.videos.length,
          teacherId
        );
        // Get quizId from currentGroup if available
        const quizId = currentGroup?._id || currentGroup?.quizId || currentGroup?.id || null;
        console.log("Completing quiz - currentGroup:", currentGroup, "quizId:", quizId);
        const response = await QuizServices.completeProcess(
          teacherId,
          null, // Course name will be identified by backend
          quizId // Pass quizId to backend
        );
        console.log(response, "Quiz completion response");
      } catch (error) {
        console.error("Error completing quiz:", error);
      }
    }
  };
  const handleAnswer = async (answer) => {
    if (!currentQuestion) return;

    if (answer === currentQuestion.correctAnswer) {
      setMessage("✅ Correct! Moving to the next question...");
      setTimeout(async () => {
        setMessage("");
        setAnswerSelected(false); // Re-enable checkboxes
        if (currentQuestionIndex + 1 < currentGroup.questions.length) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else if (currentGroupIndex + 1 < currentVideo.quizzes.length) {
          // Completed all questions in current quiz group - record completion
          try {
            const quizId = currentGroup?._id || currentGroup?.quizId || currentGroup?.id || null;
            console.log("Completing quiz group - currentGroup:", currentGroup, "quizId:", quizId);
            await QuizServices.completeProcess(
              teacherId,
              null, // Course name will be identified by backend
              quizId // Pass quizId to backend
            );
          } catch (error) {
            console.error("Error completing quiz group:", error);
          }

          await QuizServices.saveProcess(
            currentGroupIndex + 1,
            currentVideoIndex,
            teacherId
          );
          setCurrentGroupIndex(currentGroupIndex + 1);
          setCurrentQuestionIndex(0);
          setVideoPlayed(false);
          setShowQuestion(false);
        } else if (currentVideoIndex + 1 < apiResponse.videos.length) {
          // Completed all questions in current quiz group (last group of current video) - record completion
          try {
            const quizId = currentGroup?._id || currentGroup?.quizId || currentGroup?.id || null;
            console.log("Completing quiz group (last in video) - currentGroup:", currentGroup, "quizId:", quizId);
            await QuizServices.completeProcess(
              teacherId,
              null, // Course name will be identified by backend
              quizId // Pass quizId to backend
            );
          } catch (error) {
            console.error("Error completing quiz group:", error);
          }
          // ✅ Fixed variable
          if (currentGroup?.afterVideoVimeoId) {
            setAfterVideoVimeoId(currentGroup?.afterVideoVimeoId.trim());
            setIsAfterVideoVimeo(true);
          } else {
            await QuizServices.saveProcess(
              0,
              currentVideoIndex + 1,
              teacherId
            );

            // NEW LOGIC: Auto-advance to the next video immediately
            setCurrentVideoIndex(currentVideoIndex + 1);
            setCurrentGroupIndex(0);
            setCurrentQuestionIndex(0);
            setVideoPlayed(false);
            setShowQuestion(false);
            setQuizCompleted(false);
            setAnswerSelected(false);
            setSelectedOptions({});
            setMessage("");

            // Scroll to top for the new video
            window.scrollTo(0, 0);
            return;
          }
          setVideoPlayed(false);
          setShowQuestion(false);
        } else {
          // Quiz Completed - Show success message and redirect
          setQuizCompleted(true);

          try {
            // Get quizId from currentGroup if available
            const quizId = currentGroup?._id || currentGroup?.quizId || currentGroup?.id || null;
            console.log("Completing quiz after answering all questions - currentGroup:", currentGroup, "quizId:", quizId);
            await QuizServices.completeProcess(
              teacherId,
              null,
              quizId
            );

            // Show congratulations and redirect
            Swal.fire({
              title: "Congratulations!",
              text: "You have successfully completed this module.",
              icon: "success",
              confirmButtonText: "Return to Dashboard",
            }).then(() => {
              window.location.href = "/main-dashboard";
            });

          } catch (error) {
            console.error("Error completing quiz:", error);
            // Even if error, try to redirect if it was just a duplicate completion
            Swal.fire({
              title: "Completed!",
              text: "Return to dashboard to continue.",
              icon: "success",
              confirmButtonText: "Dashboard",
            }).then(() => {
              window.location.href = "/main-dashboard";
            });
          }

          return; // Stop execution here since we are redirecting

        }
        setSelectedOptions({}); // Reset selected options
      }, 1000);
    } else {
      setMessage("❌ Incorrect! Please watch the video again.");
      setShowReplay(true);
    }
  };

  const handleReplay = () => {
    setShowReplay(false);
    setMessage("");
    setVideoPlayed(false);
    setShowQuestion(false);
    setAnswerSelected(false); // Reset answer selection
    setSelectedOptions({});
  };

  const handlequizretake = () => {
    setCurrentVideoIndex(0);
    setCurrentGroupIndex(0);
    setCurrentQuestionIndex(0);
    setVideoPlayed(true);
    setiscompleted(false);
    setShowQuestion(true);
    setShowReplay(false);
    setMessage("");
    setQuizCompleted(false);
  };

  return (
    <DashboardLayout
      role={finalRole}
      userType={userType}
      layoutType="topnav"
      activeMenu="Quiz"
      showBreadcrumbs={true}
    >
      <div className="row">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="breadcrumb-list">
                <h2 className="breadcrumb-title">Quiz</h2>
                {/* <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={process.env.REACT_APP_URL}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Dashboard
                      </li>
                    </ol>
                  </nav> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {iscompleted ? (
        <>
          <div className="page-content">
            <div className="container">
              <div className="row">
                <div className="col-xxl-12 col-md-12">
                  <div className="card">
                    <div className="card-body text-center py-5">
                      <h3 className="mb-4">
                        🎉 Congratulations! You&apos;ve completed your Active Shooter and
                        Emergency Protocols Certification
                      </h3>
                      <p className="text-muted mb-4">
                        You can review any module or retake the entire course.
                      </p>
                      <div className="d-flex gap-2 justify-content-center mb-4">
                        <Link
                          to={role == 3 ? "/teacher-certifications" : role == 2 ? "/schoolteacher-certifications" : "/certificates"}
                          className="btn btn-success"
                        >
                          <i className="bx bx-certificate me-1"></i>
                          View Certificates
                        </Link>
                        <button
                          className="btn btn-primary"
                          onClick={handlequizretake}
                        >
                          <i className="bx bx-refresh me-1"></i>
                          Retake Course
                        </button>
                        <Link
                          to={role == 3 ? "/teacher-dashboard" : role == 2 ? "/schoolteacher-dashboard" : "/main-dashboard"}
                          className="btn btn-outline-secondary"
                        >
                          <i className="bx bx-home me-1"></i>
                          Back to Dashboard
                        </Link>
                      </div>
                      {apiResponse && apiResponse.videos && apiResponse.videos.length > 0 && (
                        <div className="mt-4">
                          <h5 className="mb-3">Course Modules</h5>
                          <div className="row">
                            {apiResponse.videos.map((video, videoIndex) => (
                              <div key={videoIndex} className="col-md-6 col-lg-4 mb-3">
                                <div className="card h-100 shadow-sm">
                                  <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                      <span className="badge bg-primary">Module {videoIndex + 1}</span>
                                      <span className="badge bg-success">Completed</span>
                                    </div>
                                    <h6 className="card-title mb-2">{video.description || `Module ${videoIndex + 1}`}</h6>
                                    {video.quizzes && video.quizzes.length > 0 && (
                                      <p className="text-muted small mb-3">
                                        <i className="bx bx-list-check me-1"></i>
                                        {video.quizzes.length} quiz{video.quizzes.length > 1 ? 'zes' : ''} included
                                      </p>
                                    )}
                                    <button
                                      className="btn btn-sm btn-outline-primary w-100"
                                      onClick={() => {
                                        setiscompleted(false);
                                        setCurrentVideoIndex(videoIndex);
                                        setCurrentGroupIndex(0);
                                        setVideoPlayed(true);
                                        setShowQuestion(true);
                                      }}
                                    >
                                      <i className="bx bx-refresh me-1"></i>
                                      Review Module
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* <SchoolSidebar /> */}
              <div className="col-xl-12 col-lg-12">
                <div className="row justify-content-center">
                  <div className="dashboard-title">
                    <h2>{currentGroup?.videoName || currentVideo?.title || "Loading Video..."} <span style={{ fontSize: "10px", color: "#ccc" }}>(v2.2)</span></h2>
                    <p>{currentVideo?.description || ""}</p>
                  </div>
                  <div className="col-lg-12 col-md-12 d-flex">
                    <div className="card dash-info flex-fill">
                      <div className="card-body">
                        {!videoPlayed && currentVideoVimeoId && !showQuestion && (isAfterVideoVimeo ? afterVideoVimeoId : currentVideoVimeoId) && (
                          <VimeoPlayer
                            key={
                              isAfterVideoVimeo
                                ? afterVideoVimeoId
                                : currentVideoVimeoId
                            }
                            videoId={
                              isAfterVideoVimeo
                                ? afterVideoVimeoId
                                : currentVideoVimeoId
                            }
                            onVideoEnd={handleVideoEnd}
                          />
                        )}
                        {videoPlayed && !showQuestion && currentVideoVimeoId && (
                          <div className="alert alert-info">
                            Video completed. Use the button below to finish the course.
                          </div>
                        )}

                        {/* Fallback Finish Button for Video 8 (Index 7) */}
                        {currentVideoIndex === 7 && (
                          <div className="mt-4 text-center">
                            <button
                              className="btn btn-success btn-lg pulse-button"
                              onClick={handleFinishCourse}
                            >
                              <i className="bx bx-check-circle me-1"></i>
                              Finish Course & Get Certificate
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="dashboard-title replay-video-section">
                  {message && <div className="alert alert-info"><h5 className="mb-0">{message}</h5></div>}
                  {showReplay && (
                    <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                      <button
                        className="replay-video"
                        onClick={handleReplay} // This forces rewatch
                        style={{ padding: "10px", backgroundColor: "#6c757d", color: "white", border: "none" }}
                      >
                        🔄 Replay Video
                      </button>

                    </div>
                  )}

                  {/* Thank You Message */}
                  {quizCompleted && (
                    <div className="col-xxl-12 col-md-12">
                      <h3>🎉 Thank you for completing the quiz!</h3>
                      <button
                        style={{ width: "100px" }}
                        className={"success"}
                        onClick={handlequizretake}
                      >
                        Retake
                      </button>
                      <p></p>
                    </div>
                  )}
                </div>

                <div className="row">
                  {!quizCompleted && showQuestion && currentQuestion && (
                    <div className="col-xxl-12 col-md-12 d-flex">
                      <div className="course-box flex-fill">
                        <div className="product teacher-quiz-product">
                          <h4 style={{ color: "green" }}>
                            {currentQuestion.bonusQuestion
                              ? "Bonus Question*"
                              : ""}{" "}
                          </h4>
                          <h5>
                            {currentGroup?.group} -{" "}
                            {currentQuestion.questionText}{" "}
                          </h5>
                          {currentQuestion.options.map((option, index) => (
                            <label key={index}>
                              {" "}
                              {/* Adding key to the label */}
                              <input
                                type="checkbox"
                                name={option.text} // Or any other unique identifier
                                checked={
                                  selectedOptions[option.text] || false
                                }
                                onClick={() => handleAnswer(option.text)} // If you want to handle the answer on checkbox click
                                style={{ margin: "10px", padding: "10px" }}
                                onChange={handleCheckboxChange}
                                disabled={answerSelected}
                              />
                              {option.text}
                            </label>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default Test;
